<template>
  <v-container class="d-flex flex-column align-center" fluid>
    <div style="max-width: 1000px">
      <div class="d-flex justify-center">
        <h2 class="mb-6">{{ $t('avatar.select') }}</h2>
      </div>
      <div
        v-for="n in avatarsSize"
        class="d-inline-block pa-2 avatar"
        :key="n"
        @click="user.avatar = n"
        v-bind:class="{
          selected: user.avatar === n,
        }"
      >
        <img alt="Avatar" :src="require('@/assets/avatars/Frame-' + n + '.svg')" />
      </div>
      <div class="grid grid-cols-2 gap-1">
        <v-btn to="/profile" class="mt-2" block color="secondary">{{ $t('back') }}</v-btn>
        <v-btn
          block
          class="mt-2"
          color="secondary"
          @click="submit"
          :disabled="!this.user.avatar || loading"
          >{{ $t('next') }}</v-btn
        >
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Avatar',
  data: () => ({
    loading: false,
    avatarsSize: parseInt(require.context('@/assets/avatars', false, /\.(svg)$/).keys().length) - 1,
    user: {
      avatar: null,
    },
  }),

  methods: {
    submit() {
      this.loading = true;
      this.axios
        .post('/api/v1/profile/avatar', this.user)
        .then(() => {
          console.log('Success');
          this.$store.commit('setAvatar', this.user.avatar);
          let redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.push({
              name: redirect,
            });
          } else {
            this.$router.push({
              name: 'Dashboard',
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.avatar:hover {
  box-shadow: 0 0 11px white;
  cursor: pointer;
}
.avatar.selected {
  box-shadow: 0 0 11px #4bace9;
  opacity: 0.8;
}
</style>
